import {AppLayout} from "../layout/AppLayout.tsx";
import {PublicHomePage} from "../features/home/pages/PublicHomePage.tsx";
import {SignOutPage} from "../features/home/pages/SignOutPage.tsx";
import {AboutPage} from "../features/home/pages/AboutPage.tsx";
import {ProductsPage} from "../features/home/pages/ProductsPage.tsx";
import {RequireAuth} from "../utils/RequireAuth.tsx";
import {MessagesLayout} from "../features/messages/layout.tsx";
import {AliasesLayout} from "../features/aliases/layout.tsx";
import {ContactsLayout} from "../features/contacts/layout.tsx";
import {TagsLayout} from "../features/tags/layout.tsx";
import {PersonasLayout} from "../features/personas/layout.tsx";
import {AdministrationLayout} from "../features/administration/layout.tsx";
import {ApplicationErrorPage} from "@flexinet/ui-components";
import {PricingConfigProvider, PricingPage} from "@flexinet/pricing-components";
import {publicPricingConfig} from "./pricing.ts";
import {ApplicationProductsLayout} from "../features/application-products/layout.tsx";
import {AccountSettingsLayout} from "../features/account-settings/layout.tsx";
import {AnalyticsLayout} from "../features/analytics/layout.tsx";

export const routesConfig = [{
    path: '/',
    element: <AppLayout/>,
    errorElement: <ApplicationErrorPage/>,
    children: [{
        index: true,
        element: <PublicHomePage/>
    }, {
        path: 'sign-out',
        element: <SignOutPage/>
    }, {
        path: 'about',
        element: <AboutPage/>
    }, {
        path: 'products',
        element: <ProductsPage/>
    }, {
        path: 'pricing',
        element: <PricingConfigProvider config={publicPricingConfig}><PricingPage/></PricingConfigProvider>
    }, {
        path: 'messages/*',
        element: <RequireAuth><MessagesLayout/></RequireAuth>
    }, {
        path: 'analytics/*',
        element: <RequireAuth><AnalyticsLayout/></RequireAuth>
    }, {
        path: 'account-settings/*',
        element: <RequireAuth><AccountSettingsLayout/></RequireAuth>
    }, {
        path: 'aliases/*',
        element: <RequireAuth><AliasesLayout/></RequireAuth>
    }, {
        path: 'tags/*',
        element: <RequireAuth><TagsLayout/></RequireAuth>
    }, {
        path: 'personas/*',
        element: <RequireAuth><PersonasLayout/></RequireAuth>
    }, {
        path: 'contacts/*',
        element: <RequireAuth><ContactsLayout/></RequireAuth>
    }, {
        path: 'application-products/*',
        element: <RequireAuth><ApplicationProductsLayout/></RequireAuth>
    }, {
        path: 'administration/*',
        element: <RequireAuth><AdministrationLayout/></RequireAuth>
    }]
}]